import { jsx } from "react/jsx-runtime";
import { useEffect } from "react";
import { LocalTranslation } from "../../../../constants/translations";
import Modal from "@m4b-design/modal";
import { RecordingStatus } from "../..";
import { removeDebugModeUrlParams } from "../../../../utils/session-replay-debug-mode-portal";
import { SessionReplayEventButton, SessionReplayEventSection } from "../../../../constants";
import useGeneralConfigs from "../../../../hooks/useGeneralConfigs";
const DebugAuthorisationMessage = (props) => {
  const {
    recordingStatus,
    setRecordingStatus,
    customAuthorisationComponent: CustomAuthorisationComponent
  } = props;
  const { userLang, teaCollectEvent } = useGeneralConfigs();
  useEffect(() => {
    teaCollectEvent == null ? void 0 : teaCollectEvent("section_show", { section: SessionReplayEventSection.ON_CALL_AUTHORISE_POPUP });
  }, []);
  const onAuthorise = () => {
    teaCollectEvent == null ? void 0 : teaCollectEvent("button_click", {
      click_for: SessionReplayEventButton.ON_CALL_AUTHORISE_REPLAY
    });
    setRecordingStatus(RecordingStatus.RECORDING);
  };
  const onExit = () => {
    teaCollectEvent == null ? void 0 : teaCollectEvent("button_click", { click_for: SessionReplayEventButton.ON_CALL_NO_AUTH });
    removeDebugModeUrlParams();
    setRecordingStatus(RecordingStatus.NO_AUTHORISATION);
  };
  const authorisationTitle = LocalTranslation.AboutToEnterDebugMode[userLang];
  const authorisationMessage = LocalTranslation.AuthorizationMessage[userLang].split("\n").map((item, i) => /* @__PURE__ */ jsx("p", { children: item }, i));
  const authoriseButtonText = LocalTranslation.EnterDebugMode[userLang];
  if (recordingStatus === RecordingStatus.GETTING_AUTHORISATION) {
    if (CustomAuthorisationComponent) {
      return /* @__PURE__ */ jsx(
        CustomAuthorisationComponent,
        {
          authorisationTitle,
          authorisationMessageContent: authorisationMessage,
          authoriseButtonText,
          exitButtonText: "Exit",
          onAuthorise,
          onExit
        }
      );
    }
    return /* @__PURE__ */ jsx(
      Modal,
      {
        title: authorisationTitle,
        visible: true,
        size: "small",
        okText: authoriseButtonText,
        cancelText: "Exit",
        onCancel: onExit,
        onOk: onAuthorise,
        okButtonProps: { style: { backgroundColor: "rgb(0, 153, 149)", color: "#fff", fontWeight: 500 } },
        children: authorisationMessage
      }
    );
  } else {
    return null;
  }
};
var debug_authorisation_message_default = DebugAuthorisationMessage;
export {
  DebugAuthorisationMessage,
  debug_authorisation_message_default as default
};
